import { useContext, useMemo } from 'react';

import { AuthContext } from '../../../contexts/AuthContext';

export const useGetHideMetrics = () => {
  const { visibleMetrics } = useContext(AuthContext);

  const hideMetrics: Record<string, boolean> = useMemo(
    () => ({
      paid_sales: !visibleMetrics.paid,
      sns_sales: !visibleMetrics.sns,
      organic_sales: !visibleMetrics.paid,
      bbx: !visibleMetrics.traffic,
      ntb: !visibleMetrics.ntb,
      page_views: !visibleMetrics.traffic,
      sessions: !visibleMetrics.traffic,
      cnv: !visibleMetrics.traffic,
      paid_impr: !visibleMetrics.paid,
      paid_clicks: !visibleMetrics.paid,
      paid_orders: !visibleMetrics.paid,
      paid_units: !visibleMetrics.paid,
      sns_units: !visibleMetrics.sns,
      wk8_units: !visibleMetrics.sns,
      subscriptions: !visibleMetrics.sns,
    }),
    [visibleMetrics],
  );

  return { hideMetrics };
};
